<template>
    <dashboard/>
     <div class="modal-dialog modal-lg downchange">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myLargeModalLabel">Send Notification to All User</h5>
              </div>
              <div class="modal-body">
                <div class="row">
               <div class="col-lg-4 col-md-12 col-sm-12">
                 <div class="form-group">
                   <label>Title</label>
                   <input type="text" v-model="title" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Description</label>
                    <textarea type="text" v-model="description"  class="form-control" ></textarea>
                  </div>
                </div>
               <div class="col-lg-12 col-md-12 col-sm-12">
                 <DoubleBounce  v-if="showLoader"></DoubleBounce>
                 <input type="button" @click="SendNotification"   v-else value="Send" class="modal-btn" />
               </div>
             </div>
              </div>
            </div>
          </div>
  </template>
  
  <script>
  import {DoubleBounce} from 'vue-loading-spinner'
  import { defineComponent } from 'vue'
  import { createToast } from 'mosha-vue-toastify';
  import 'mosha-vue-toastify/dist/style.css'
  import axios from "../services/customAxios";
  import { base_url } from "../config";
  import Dashboard from '../components/Dashboard.vue';
  export default defineComponent({
    name: "ChangePass",
    components: { Dashboard,DoubleBounce },
    setup () {
      const toast = () => {
          createToast()
      }
      return { toast }
    },
    data(){
      return{
        result:[],  
        title: "",
        description: "",
        showLoader:false,
        base_url: base_url,
      }
    },
    methods: { 
      async SendNotification() {
        this.showLoader = true
    try{
       let response = await axios.post(`${base_url}/send_notification`, {
         title: this.title,
         description: this.description,
       });
      //  console.log("check result==>", response.data.status);
      createToast({title: "Success", description: response.data.message},{type: "success"})
       if(response.data.success == true){
        this.$router.push('/dashboard')
       }
      }
      catch(error){
        this.showLoader = false
        createToast({title: "Error", description: error?.response?.data?.message},{type: "danger"})
      }
   }, 
     cross(){
      window.location.reload();
     },
    },
  });
  </script>
  
  <style>
  .downchange{
      margin-top: 5%;
      margin-left: 30%;
  }
  </style>